<template>
  <div v-if="showInfoPanel && markerInfo" class="pressure-panel"
    :style="{ backgroundImage: `url(${backgroundImage})` }">
    <h4 class="panel-title">压力表详情</h4>
    <button class="print-btn" @click="printInfo">
      <img src="@/assets/pressure/u57.svg" alt="打印" />
    </button>
    <button class="delete-btn" @click="closeInfoPanel">
      <img src="@/assets/pressure/u60.svg" alt="删除" />
    </button>
    <div id="info-content" class="info-content">
      <div class="info-item">
        <span class="info-label">安装地址:</span>
        <span class="info-value" :title="markerInfo.address || '暂无数据'">{{ markerInfo.address || '暂无数据' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">表身号:</span>
        <span class="info-value">{{ markerInfo.piezometerNo || '暂无数据' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">状态:</span>
        <span class="info-value">{{ markerInfo.status || '未知' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">压力值:</span>
        <span class="info-value" :class="'pressure-' + (markerInfo.status || '未知')">{{ markerInfo.piezometerValue ||
          '暂无数据' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import u45Svg from '@/assets/pressure/u45.svg'
import printJs from 'print-js'

export default {
  name: 'MarkerInfoPanel',
  props: {
    showInfoPanel: {
      type: Boolean,
      default: false
    },
    markerInfo: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      backgroundImage: u45Svg
    }
  },
  methods: {
    closeInfoPanel () {
      this.$emit('close-panel');
    },
    printInfo () {
      const style = `
        @page { margin: 10mm; }
        .info-item {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          line-height: 30px !important;
          page-break-inside: avoid !important;
          width: 100% !important;
        }
        .info-label {
          font-size: 14px !important;
          color: #000 !important;
          flex-shrink: 0 !important;
          margin-right: 10px !important;
        }
        .info-value {
          font-size: 14px !important;
          color: #000 !important;
          text-align: right !important;
          word-break: break-all !important;
        }
        .pressure-正常 { color: #52c41a !important; font-weight: bold !important; }
        .pressure-高压 { color: #ff4d4f !important; font-weight: bold !important; }
        .pressure-低压 { color: #1890ff !important; font-weight: bold !important; }
        .pressure-采集异常 { color: #fa8c16 !important; font-weight: bold !important; }
        .pressure-未知 { color: #999999 !important; font-weight: bold !important; }
      `

      try {
        printJs({
          printable: 'info-content',
          type: 'html',
          scanStyles: false,
          style: style,
          header: '<h3 style="text-align: center; margin: 10px 0;">压力表详情</h3>'
        })
      } catch (error) {
        console.error('打印失败:', error);
        this.$message.error('打印失败，请重试');
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 压力表面板样式 - 只有背景框
.pressure-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 251px;
  height: 199px;
  background: url('../../../../assets/pressure/u45.svg') no-repeat center center;
  background-size: cover;
  border-radius: 8px;
  z-index: 1001;
  overflow: hidden;
}

.panel-title {
  position: absolute;
  top: 10px;
  left: 20px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.print-btn {
  position: absolute;
  top: 15px;
  right: 40px;
  width: 22px;
  height: 22px;
  background: #4eb0ff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  padding: 0;
}

.print-btn:hover {
  background: #3a9eff;
}

.print-btn img {
  width: 12px;
  height: 12px;
  filter: brightness(0) invert(1);
}

.delete-btn {
  position: absolute;
  top: 15px;
  right: 12px;
  width: 22px;
  height: 22px;
  background: #4eb0ff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  padding: 0;
}

.delete-btn:hover {
  background: #3a9eff;
}

.delete-btn img {
  width: 12px;
  height: 12px;
  filter: brightness(0) invert(1);
}

.info-content {
  position: absolute;
  top: 45px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  padding: 12px;
  overflow-y: auto;
  z-index: 5;
}

.info-item {
  display: flex;
  margin-bottom: 8px;
  align-items: baseline;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  width: 60px;
  font-size: 14px;
  color: #666666;
  flex-shrink: 0;
  font-weight: 500;
  text-align: right;
  margin-right: 8px;
}

.info-value {
  flex: 1;
  font-size: 14px;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
}

.info-value.pressure-正常 {
  color: #52c41a;
}

.info-value.pressure-高压 {
  color: #ff4d4f;
}

.info-value.pressure-低压 {
  color: #1890ff;
}

.info-value.pressure-采集异常 {
  color: #fa8c16;
}

.info-value.pressure-未知 {
  color: #999999;
}

// 响应式设计
@media (max-width: 768px) {
  .pressure-panel {
    width: 220px;
    height: 180px;
    top: 10px;
    right: 10px;
  }
}
</style>